import { OdataManager } from '@/api/odata/odata-manager';
import { PackageKS2DocumentStatus } from '@/api/model/interfaces';

export default class PackageKS2DocumentStatusOdata extends OdataManager<PackageKS2DocumentStatus> {}
